import { emptyInternalReferenceMapCfn } from './empty-internal-reference-map.cfn';

import type { InternalReferenceMap, ReferenceMap } from '../../shared.types';

/**
 * Resolves an internal reference map into its public form.
 * Collection slots are filled from their owning ancestor because a node only inherits the slots of its own ancestors, leaving cousin collections (obstructions under KitchenDesign, for example) permanently null.
 * @param internalRefMap the snapshot built during construction
 * @returns the public reference map with a resolved id and every reachable collection slot populated
 */
export const resolveReferenceMapCfn = (internalRefMap: InternalReferenceMap): ReferenceMap => {
	const {
		breakpoints,
		id,
		island,
		islands,
		kitchen,
		kitchenDesign,
		notifications,
		obstructions,
		panel,
		panelItemGroups,
		panels,
		promotionalSkus
	} = internalRefMap ?? emptyInternalReferenceMapCfn();

	const design = kitchenDesign ?? kitchen?.design ?? null;

	return {
		...internalRefMap,
		id: id() || null,
		breakpoints: breakpoints ?? panel?.breakpoints ?? null,
		islands: islands ?? design?.islands ?? null,
		notifications: notifications ?? design?.notifications ?? null,
		obstructions: obstructions ?? design?.obstructions ?? null,
		panelItemGroups: panelItemGroups ?? panel?.panelItemGroups ?? null,
		panels: panels ?? island?.panels ?? null,
		promotionalSkus: promotionalSkus ?? kitchen?.promotionalSkus ?? null
	};
};
